import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let paywallHandler = null;

/** Called once at app startup. Whenever a request returns 402 with our
 *  structured paywall detail, invoke the modal opener. */
export function installPaywallInterceptor(open) {
  paywallHandler = open;
}

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 402 && paywallHandler) {
      const detail = err.response.data?.detail;
      if (detail && typeof detail === "object" && detail.error === "paywall") {
        paywallHandler(detail);
      } else {
        paywallHandler({ message: "Renew to keep going." });
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  // Rate-limit and monthly-cap responses ship a friendly `message` field.
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
